import router from '../router';
import store from '../store';
import UserAPI from '@/web-framework/api/user';
import MenuAPI from '@/web-framework/api/menu';
import Constants from '@/public/api/constants.js';
const pathToRegexp = require('path-to-regexp');

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken, removeToken } from '@/web-framework/api/token';

NProgress.configure({
    showSpinner: false
});

const whiteList = [
    '/ceping',
    '/ceping/(.*)',
    '/public/(.*)',
    '/noright',
    '/space/(.*)',
    '/category/(.*)',
    '/cms/article/(.*)',
    '/cms/channel/(.*)',
    '/aboutus',
    '/cases',
    '/deny',
    '/cases/*',
    'products',
    'service',
    'news',
    '/login',
    '/regist',
    '/wxlogin/(.*)',
    '/auth-redirect',
    '/cart',
    '/pub/(.*)',
    '/shop',
    '/diagram_score_analysis',
    '/diagram_cutoff_score_line',
    '/g/preview2027',
    '/g/(.*)'
];

router.beforeEach(async(to, from, next) => {
    NProgress.start();

    if (!store.getters.siteInfo || !store.getters.siteInfo.SITE_NAME) {
        // 初始化，并加载网站信息
        store.dispatch('site/loadSiteInfo');
    }
    // 检查IP黑名单
    if (to.path != '/deny') {
        let denied = await checkWihteAndBlackList();
        if (denied) {
            next(`/deny`);
            NProgress.done();
            return;
        }
    } else {
        // 如果当前没有被禁用，则跳转到主页去
        let denied = await checkWihteAndBlackList();
        if (!denied) {
            next(`/`);
            NProgress.done();
            return;
        } else {
            next();
            NProgress.done();
            return;
        }
    }
    let codes = store.getters.codes;
    if (!codes || Object.keys(codes).length == 0) {
        await store.dispatch('code/loadCodes');
    }

    // 检查是否已拥有令牌，如果
    // 如果只有token，没有用户信息，则尝试获取用户信息。如果获取用户信息失败，且当前访问的是受保护的资源，则清除token，并重定向到登录
    // 如果只有token，没有用户信息，则尝试获取用户信息，如果获取用户信息成功，则进入。
    // 如果没有token，没有用户信息，则跳转到登录
    // 对登录页面和首页均不做过滤
    // 检查当前用户是否已经加载了菜单或已经切换了身份，如果没有，则需要切换身份或重新加载菜单
    if (!hasToken() && !isWhiteListUrl(to.path)) {
        // 没有token，且访问的是需要登录的地址，则此时跳转到登录页面
        next(`/login`);
        NProgress.done();
        return;
    } else if (!hasToken() && isWhiteListUrl(to.path)) {
        // 没有token，且访问的是无需登录的地址，则不做限制，直接访问
        next();
    } else if (hasToken() && hasUserInfo() && !isWhiteListUrl(to.path)) {
        UserAPI.checkUserRoleFromRoute(to.path);
        // 有token，有用户信息，则无论访问的是哪种地址，均直接访问
        if (!routesLoaded()) {
            if (!loadRoutes()) {
                // 加载路由数据失败，则终止跳转
                removeToken();
                next(`/login`);
                NProgress.done();
                return;
            }
        }
        next();
    } else if (hasToken() && hasUserInfo() && isWhiteListUrl(to.path)) {
        // 有token，有用户信息，则无论访问的是哪种地址，均直接访问
        next();
    } else if (hasToken() && !hasUserInfo() && !isWhiteListUrl(to.path)) {
        // 有token，但是无用户信息，且当前访问的是需要登录的地址，则尝试获取用户信息
        try {
            await UserAPI.ensureUserInfoCached();
        } catch (error) {
            if (error && typeof error.code && error.code == -713) {
                next(`/noright`);
                NProgress.done();
                return;
            }
            // 清除用户token
            removeToken();
            next(`/login`);
            NProgress.done();
            return;
        }
        UserAPI.checkUserRoleFromRoute(to.path);
        if (!routesLoaded()) {
            if (!loadRoutes()) {
                // 加载路由数据失败，则终止跳转
                removeToken();
                next(`/login`);
                NProgress.done();
                return;
            }
        }

        let userRole = sessionStorage.getItem('currentUserRole');
        if (userRole) {
            let currentUserRole = JSON.parse(userRole);
            next(currentUserRole.entrancePath);
        } else {
            // 获取到用户信息后，进入
            if (to.path != Constants.APP_CONTEXT) {
                next(Constants.APP_CONTEXT);
            } else {
                next();
            }
        }
    } else if (hasToken() && !hasUserInfo() && isWhiteListUrl(to.path)) {
        // 有token，但是无用户信息，且当前访问的是无需登录的地址，则尝试 获取用户信息，但在用户信息获取失败时清除token，但仍然允许进入
        try {
            await UserAPI.ensureUserInfoCached();
        } catch (error) {
            // 清除用户token
            removeToken();
        }

        // 获取到用户信息后，进入
        next();
    }
});

function checkWihteAndBlackList() {
    return new Promise((resolve, reject) => {
        if (store.getters.siteInfo && ((store.getters.siteInfo.blacklist && store.getters.siteInfo.blacklist.length > 0) || (store.getters.siteInfo.whitelist && store.getters.siteInfo.whitelist.length > 0))) {
            UserAPI.getIp().then(result => {
                    if (result && result.success && result.data) {
                        let currentIp = result.data;
                        if (store.getters.siteInfo.blacklist && store.getters.siteInfo.blacklist.length > 0) {
                            if (currentIp.length > 0 && store.getters.siteInfo.blacklist.indexOf(currentIp) != -1) {
                                resolve(true);
                            }
                        }

                        if (store.getters.siteInfo.whitelist && store.getters.siteInfo.whitelist.length > 0) {
                            if (currentIp.length > 0 && store.getters.siteInfo.whitelist.indexOf(currentIp) == -1) {
                                resolve(true);
                            }
                        }
                    }
                    resolve(false);
                })
                .catch(error => {
                    resolve(false);
                });
        } else {
            resolve(false);
        }
    });
}

/**
 * 判断用户是否有令牌
 */
function hasToken() {
    let token = getToken();
    return token && token.length > 0;
}

/**
 * 检查是否具有用户信息了
 */
function hasUserInfo() {
    return store.getters.user && store.getters.user.id;
}

/**
 * 判断是否已经加载了路由信息数据
 */
function routesLoaded() {
    if (!store.getters.routes || store.getters.routes.length == 0) {
        return false;
    }
    return true;
}

/**
 * 判断公共路由是否已经加载
 * @returns 
 */
function frameworkRoutesLoaded() {
    return store.getters.isFrameworkRouteLoaded;
}

/**
 * 读取公共路由
 * @returns 
 */
async function loadFrameworkRoutes() {
    try {
        await MenuAPI.initFrameworkMenus();
        return true;
    } catch (exception) {
        return false;
    }
}

/**
 * 加载路由信息数据
 */
async function loadRoutes() {
    try {
        await MenuAPI.initMenus();
        return true;
    } catch (exception) {
        return false;
    }
}

function isWhiteListUrl(str) {
    if (whiteList.indexOf(str) != -1) return true;

    for (let i = 0; i < whiteList.length; i++) {
        let url = whiteList[i];
        if (pathToRegexp(url).test(str)) return true;
    }
    return false;
}

router.afterEach(() => {
    NProgress.done();
});